/* The Charm Lab — language switch in the phone menu.

   The header's English / Thai selector is hidden on phones to save room, so
   this adds the same choice to the bottom of the phone menu once theme.js has
   built it. Choosing a language submits the header's own localization form,
   so Shopify handles the switch exactly as it does on desktop. */
(function () {
  'use strict';

  var sel = document.getElementById('HeaderLanguage');
  var mob = document.getElementById('mobmenu');
  if (!sel || !mob || sel.options.length < 2) return;

  var style = document.createElement('style');
  style.textContent = '.moblang{display:flex;flex-wrap:wrap;gap:8px;margin-top:4px}'
    + '.moblang button{font-family:var(--mono);font-size:.74rem;letter-spacing:.06em;border:1px solid var(--line);'
    + 'background:var(--paper);color:var(--ink-soft);padding:10px 16px;border-radius:var(--r);cursor:pointer}'
    + '.moblang button[aria-current]{border-color:var(--ink);color:var(--ink)}';
  document.head.appendChild(style);

  var labelEl = document.querySelector('label[for="HeaderLanguage"]');
  var label = labelEl ? labelEl.textContent.trim() : 'Language';

  function add() {
    if (!mob.dataset.built || mob.querySelector('.moblang')) return;
    var head = document.createElement('div');
    head.className = 'grp';
    head.textContent = label;
    var row = document.createElement('div');
    row.className = 'moblang';
    [].forEach.call(sel.options, function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.lang = o.value;
      b.setAttribute('data-moblang', o.value);
      if (o.selected) b.setAttribute('aria-current', 'true');
      b.textContent = o.textContent.trim();
      row.appendChild(b);
    });
    mob.appendChild(head);
    mob.appendChild(row);
  }

  mob.addEventListener('click', function (e) {
    var b = e.target.closest('[data-moblang]');
    if (!b || b.hasAttribute('aria-current')) return;
    sel.value = b.getAttribute('data-moblang');
    var form = sel.closest('form');
    if (form) form.submit();
  });

  new MutationObserver(add).observe(mob, { childList: true });
  add();
})();